import Rate from './rate.element.js';

export default Rate;

Rate.define('wje-rate', Rate);
